import type { FC } from 'react';
import React from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export type RubyIconProps = React.ReactComponentElement<'svg'>['props'];
export const RubyIcon: FC<RubyIconProps> = (props) => {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 17 14"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('size-[13px]', props.className)}
    >
      <path
        d="M10.9358 4.0095L9.60703 0H6.86135L5.54049 4.0095H10.9358Z"
        // fill="#12EEB1"
        fill="currentColor"
      />
      <path
        d="M2.97351 0L0.0332031 4.0095H4.48536L5.80615 0H2.97351Z"
        fill="currentColor"
      />
      <path
        d="M16.4454 4.0095L13.5051 0H10.6631L11.9919 4.0095H16.4454Z"
        fill="currentColor"
      />
      <path
        d="M12.2309 5.01191L9.22941 13.8231L16.4415 5.01191H12.2309Z"
        fill="currentColor"
      />
      <path
        d="M8.2393 14L11.1636 5.03094H5.27451L8.2393 14Z"
        fill="currentColor"
      />
      <path
        d="M0.0387962 5.01191L7.21328 13.7749L4.24807 5.01191H0.0387962Z"
        fill="currentColor"
      />
    </svg>
  );
};
